const dev = {
 SPOTIFY_CLIENT_ID: process.env.REACT_APP_SPOTIFY_CLIENT_ID || `82f0255fb9cc45918586aadf04ecf19a`,
 SPOTIFY_CLIENT_SECRET:  process.env.REACT_APP_SPOTIFY_CLIENT_SECRET || `46e7dfa5dee5438a9ed5ec78b0bff664`,
 SPOTIFY_REDIRECT_URI: `https://chilllists.web.app/login`,
 SPOTIFY_ACCOUNT_SERVICE_URI:  process.env.REACT_APP_SPOTIFY_ACCOUNT_SERVICE_URI || `https://accounts.spotify.com/api/token`,
 SPOTIFY_AUTHORIZE_URI:  process.env.REACT_APP_SPOTIFY_AUTHORIZE_URI || `https://accounts.spotify.com/authorize`
}

export default dev